// ported from https://netbasal.com/automagically-unsubscribe-in-angular-4487e9853a88
import { Subscription } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isFunction = (fn: any) => typeof fn === 'function';

const doUnsubscribe = (subscription: Subscription) =>
  subscription && isFunction(subscription.unsubscribe) && subscription.unsubscribe();

const doUnsubscribeIfArray = (subscriptionsArray: Subscription[]) =>
  Array.isArray(subscriptionsArray) && subscriptionsArray.forEach(doUnsubscribe);

export function AutoUnsubscribe({ blackList = [], arrayName = '', event = 'ngOnDestroy' } = {}) {
  return function (constructor: Function) {
    const original = constructor.prototype[event];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor.prototype[event] = function (...args: any) {
      if (arrayName) {
        if (isFunction(original)) {
          original.apply(this, args);
        }
        doUnsubscribeIfArray(this[arrayName]);
        return;
      }

      if (isFunction(original)) {
        original.apply(this, args);
      }

      for (const propName in this) {
        // @ts-ignore
        if (blackList.includes(propName)) {
          continue;
        }

        const property = this[propName];
        doUnsubscribe(property);
      }
    };
  };
}
